var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{staticStyle:{"margin-top":"100px","margin-bottom":"400px"},attrs:{"src":require("../images/ilearningtips.png")}})])
}]

export { render, staticRenderFns }